export const HOME_TITLE = "Home - Do you waste your time?";
export const CONTACT_US_TITLE = "Contact Us - Do you waste your time?";
export const TEST_TITLE = "Test - Do you waste your time?";
export const ADVICE_TITLE = "Time Management Advices - Do you waste your time?";
export const TEST_RESULT_TITLE = "Test Result - Do you waste your time?";
export const DAY_TIMER_TITLE = "Day Timer - Do you waste your time?";
